// Lumen Academy — Syllabus folio (Academic navy #14213D · Cream #F5EFE0 · Signal yellow #F1C40F)
export const META = { brand: 'Lumen Academy', tag: 'Cohort-based · 12-week intensives · Est. 2018', est: '2018' };
export const ROUTES = [
  { id: 'home', label: 'Faculty', no: 'I' },
  { id: 'cohort', label: 'Spring cohort', no: 'II' },
  { id: 'syllabus', label: 'Syllabus', no: 'III' },
  { id: 'apply', label: 'Apply', no: 'IV' },
];

export const TRACKS = [
  { code: 'ENG-201', t: 'Production engineering', faculty: 'A. Dvorak (ex-Stripe SRE)', seats: '24 / 24', wks: 12, price: '$4,800', d: 'Building, deploying and operating production systems at scale. Live ops on a real cluster.' },
  { code: 'DSN-204', t: 'Identity systems', faculty: 'M. Halcyon (ex-Pentagram)', seats: '20 / 24', wks: 12, price: '$4,800', d: 'Designing brand systems for software companies. Eight projects, four critiques.' },
  { code: 'BIZ-208', t: 'Founder economics', faculty: 'E. Vance (founder, Mira Health)', seats: '18 / 18', wks: 8, price: '$3,400', d: 'A weekly seminar with eighteen founders on capital, ownership, runway, and exits.' },
];

export const WEEKS = [
  { wk: '01', t: 'Foundations · what good looks like', read: 'Hardy, Pirsig, B. Lawson', drop: 'Reading précis · 800 words' },
  { wk: '02', t: 'The first hard problem', read: 'Hamming, ch. 4', drop: 'Brief written argument' },
  { wk: '03', t: 'Constraints, deliberately chosen', read: 'Krier, Eames archive', drop: 'Set of three sketches' },
  { wk: '04', t: 'A working system', read: 'Cline, Lowney', drop: 'Submitted system v0.1' },
  { wk: '05', t: 'Iteration & honest critique', read: 'Schön, ch. 2', drop: 'Self-review memo' },
  { wk: '06', t: 'Critique week · presentations', read: '—', drop: 'In-class critique' },
  { wk: '07', t: 'Mid-term · production posture', read: 'Beck, Fowler', drop: 'Mid-term system review' },
  { wk: '08', t: 'Production posture', read: 'Beck, Fowler', drop: 'Submitted system v0.2' },
  { wk: '09', t: 'Operating safely at scale', read: 'Allspaw, Limoncelli', drop: 'Runbook draft' },
  { wk: '10', t: 'Edge cases & failure modes', read: 'Perrow, ch. 7', drop: 'Failure dossier' },
  { wk: '11', t: 'Final assembly & rehearsals', read: '—', drop: 'Dress-rehearsal critique' },
  { wk: '12', t: 'Final review · exhibition', read: '—', drop: 'Public exhibition' },
];
